mobileSize = 1100;

$(document).ready(function () {

  $('.cookie-banner-content p').html(`We use cookies to offer you a better browsing experience, analyze site traffic, personalize content and serve targeted advertisements. To learn more or change your cookie preferences, choose <em>Manage Cookie Preferences</em>. For further information on the use of cookies and information we collect, visit our <a href="https://www.asmglobal.com/p/other/privacy-policy" target="_blank">Privacy Policy</a>.`);

  $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1100) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1100) {
    $('body').removeClass('saffireMobileSize');
  }

  // General Message
  $('.generalmessage').prependTo('header');
  $(".footerItems1 a").removeClass("button");
});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');
  $(".footerItems1 a").removeClass("button");
});


$(window).resize(function () {
  $(".footerItems1 a").removeClass("button");
});